import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { FilterPill } from "./FilterPill";
// Пилюля-фильтр с выпадающим MUI Menu. Показывает выбранную опцию вместо
// label и подсвечивается активной, когда значение установлено.
export var FilterMenu = function (_a) {
    var label = _a.label, value = _a.value, options = _a.options, _b = _a.allLabel, allLabel = _b === void 0 ? "Все" : _b, onSelect = _a.onSelect;
    var _c = useState(null), anchor = _c[0], setAnchor = _c[1];
    var selected = options.find(function (o) { return o.value === value; });
    var pick = function (v) {
        onSelect(v);
        setAnchor(null);
    };
    return (_jsxs(_Fragment, { children: [_jsx(FilterPill, { active: !!value, onClick: function (e) { return setAnchor(e.currentTarget); }, children: selected ? selected.label : label }), _jsxs(Menu, { anchorEl: anchor, open: !!anchor, onClose: function () { return setAnchor(null); }, children: [_jsx(MenuItem, { selected: !value, onClick: function () { return pick(undefined); }, children: allLabel }), options.map(function (o) { return (_jsx(MenuItem, { selected: o.value === value, onClick: function () { return pick(o.value); }, children: o.label }, o.value)); })] })] }));
};
